/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New flow rate`)
};

const es_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo caudal`)
};

const de_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Flussrate`)
};

const nl_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe flowsnelheid`)
};

const fr_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau débit`)
};

const it_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova portata`)
};

const pt_br2_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova vazão`)
};

const pt_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo caudal`)
};

const ja_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい流速`)
};

const zh_hplc_new_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新流速`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_new_flow = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_new_flow(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_new_flow", locale)
	if (locale === "en") return en_hplc_new_flow(inputs)
	if (locale === "es") return es_hplc_new_flow(inputs)
	if (locale === "de") return de_hplc_new_flow(inputs)
	if (locale === "nl") return nl_hplc_new_flow(inputs)
	if (locale === "fr") return fr_hplc_new_flow(inputs)
	if (locale === "it") return it_hplc_new_flow(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_new_flow(inputs)
	if (locale === "pt") return pt_hplc_new_flow(inputs)
	if (locale === "ja") return ja_hplc_new_flow(inputs)
	return zh_hplc_new_flow(inputs)
};